<template>
  <div>
    <h3>{{ text['0004'] }} 1/4</h3>
    <hr class="title">
    <h2>{{ text['0003'] }}</h2>
    <div class="survey-laseruse">
      <div @click="setLaserDistanceShort" class="survey" :class="{selected: laserDistance === 'short'}">
        <p><object type="image/svg+xml" data="/assets/icons/short_distance.svg"></object></p>
        <p>{{ text['0005'] }}</p>
      </div>
      <div @click="setLaserDistanceLong" class="survey" :class="{selected: laserDistance === 'long'}">
        <p><object type="image/svg+xml" data="/assets/icons/long_distance.svg"></object></p>
        <p>{{ text['0006'] }}</p>
      </div>
      <div @click="setLaserUseInside" class="survey" :class="{selected: laserInOrOut === 'in'}">
        <p><object type="image/svg+xml" data="/assets/icons/inside_use.svg"></object></p>
        <p>{{ text['0007'] }}</p>
      </div>
      <div @click="setLaserUseOutside" class="survey" :class="{selected: laserInOrOut === 'out'}">
        <p><object type="image/svg+xml" data="/assets/icons/outside_use.svg"></object></p>
        <p>{{ text['0008'] }}</p>
      </div>
    </div>

    <li v-for="error in validationErrors">{{ error }}</li>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        text:             'getText',
        laserDistance:    'laserUse/getDistance',
        laserInOrOut:     'laserUse/getInOrOut',
        validationErrors: 'getErrors',
      }),
    },
    methods: {
      ...mapActions({
        setLaserDistanceShort:  'laserUse/setDistanceShort',
        setLaserDistanceLong:   'laserUse/setDistanceLong',
        setLaserUseInside:      'laserUse/setInside',
        setLaserUseOutside:     'laserUse/setOutside',
      }),
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/screens/LaserUse.vue